import React from "react";
import { TENANT_IMPORT_COMMIT_BLOCKED_EVENT } from "../api/tenantImportCommitBlocked";
import { useAuth } from "../auth/useAuth";
import { requestAppReload } from "./appReloadCoordinator";

/**
 * Zieht die bestätigte Importsperre nach. Beim Ende auch ohne empfangenes
 * Job-/Realtime-Abschlussereignis einmal den gesamten Datenstand neu laden.
 */
export function TenantImportBlockedListener() {
  const { refreshMe, info } = useAuth();
  const importInProgress = info?.tenantImportCommitInProgress;
  const previous = React.useRef({ tenantId: info?.tenantId, blocked: importInProgress });
  React.useEffect(() => {
    const before = previous.current;
    previous.current = { tenantId: info?.tenantId, blocked: importInProgress };
    if (before.blocked && importInProgress === false && before.tenantId === info?.tenantId)
      requestAppReload({ reason: "tenant-data-replaced" });
  }, [info?.tenantId, importInProgress]);
  React.useEffect(() => {
    const onBlocked = () => {
      if (importInProgress) return;
      refreshMe().catch(() => {});
    };
    window.addEventListener(TENANT_IMPORT_COMMIT_BLOCKED_EVENT, onBlocked);
    return () => window.removeEventListener(TENANT_IMPORT_COMMIT_BLOCKED_EVENT, onBlocked);
  }, [refreshMe, importInProgress]);
  return null;
}
